import * as $echarts from "echarts";
import { specialStyle } from "@/assets/utils/specialStyle";
import * as size from "../utils/chartSize";

const commonLineCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 27)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)

    // 绘制图表
    let option = {
        tooltip: {
            backgroundColor: '#000',
            color: '#000',
            trigger: 'axis',
            axisPointer: {
                // 文字样式
                label: {
                    precision: 2, // 小数点精度
                },
                // 线样式
                lineStyle: {},
            },
            //浮层的文本样式
            textStyle: {
                fontSize: chartSizeB,
                fontFamily: 'Microsoft YaHei',
            },

            formatter: `{b} <br/> <span style='display:inline-block;margin-right:5px;
            border-radius:10px;width:10px;height:10px;background-color:#42F3FF;'></span> {a0}: {c0}`
        },
        grid: {
            left: chartSizeK,
            top: chartSizeJ,
            bottom: chartSizeI,
            right: chartSizeE,
        },
        xAxis: [{
            // data: ['数据1', '数据2', '数据3', '数据4', '数据5', '数据6'],
            data: params.xAxis,
            boundaryGap: false, // 取消两侧留白
            axisTick: { // 坐标轴刻度
                show: false,
            },
            // 刻度标签配置
            axisLabel: {
                color: "#FFF",
                rotate: 0,// 标签旋转
                margin: chartSizeN, // 标签与轴线间距
                fontFamily: 'Microsoft YaHei',
                fontSize: chartSizeA,
            },
            // 轴线配置
            axisLine: {
                show: true, // 显示坐标轴线
                lineStyle: { // 轴线样式
                    color: "rgba(255,255,255,0.6)",
                },
            },
        },],
        yAxis: [{
            axisLine: {
                lineStyle: {
                    color: "rgba(255,255,255,0.6)",
                },
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: "rgba(255, 255, 255, 0.65)",
                fontSize: chartSizeA,
                fontFamily: 'Microsoft YaHei',
            },
            splitLine: {
                lineStyle: {
                    color: "rgba(0,145,255,0.3)",
                },
            }
        },],
        series: [{
            name: params.series.name,
            data: params.series.data,
            type: 'line',
            smooth: true, // 线性
            showSymbol: false, // 圆点
            lineStyle: {
                width: 2,
                color: "#42F3FF",
            },
            itemStyle: {
                color: "#FFF",
                borderColor: "#42F3FF",
                borderWidth: 1,
            },
            areaStyle: {
                color: {
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                        offset: 0, color: 'rgba(97,228,255,0.3)' // 100% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(97,228,255,0)' // 0% 处的颜色
                    }],
                    global: false // 缺省为 false
                },
                shadowColor: "rgba(53,142,215, 0.9)", //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            }
        }]
    }
    params.chartId.setOption(option, true)
}

const doubleLineCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 24)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)

    // 绘制图表
    let option = {
        tooltip: {
            backgroundColor: '#000',
            color: '#000',
            trigger: 'axis',
            axisPointer: {
                // 文字样式
                label: {
                    precision: 2, // 小数点精度
                },
                // 线样式
                lineStyle: {},
            },
            //浮层的文本样式
            textStyle: {
                fontSize: chartSizeB,
                fontFamily: 'Microsoft YaHei',
            },
            
            formatter: `{b} <br/> 
            <span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;
            height:10px;background-color:#F7B500;'></span> {a0}: {c0} <br/>
            <span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;
            height:10px;background-color:#42F3FF;'></span> {a1} : {c1}`,
        },
        grid: {
            left: chartSizeK,
            top: chartSizeJ,
            bottom: chartSizeI,
            right: chartSizeE,
        },
        legend: {
            // data: ["类型一", "类型二"],
            data: [params.series[0].name, params.series[1].name],
            top: chartSizeM,
            right: chartSizeB,
            itemGap: chartSizeN,
            itemWidth: chartSizeF,
            itemHeight: chartSizeA,
            textStyle: {
                color: '#fff',
                fontSize: chartSizeA,
                fontFamily: 'Microsoft YaHei',
            },
            itemStyle: [{
                color: "#FFF",
            }, {
                color: "#FFF",
            }],
            inactiveColor: '#ccc', // 图例关闭时的颜色
        },
        xAxis: [{
            data: params.xAxis,
            boundaryGap: false, // 取消两侧留白
            axisTick: { // 坐标轴刻度
                show: false,
            },
            // 刻度标签配置
            axisLabel: {
                color: "#FFF",
                rotate: 0,// 标签旋转
                margin: chartSizeN, // 标签与轴线间距
                fontFamily: 'Microsoft YaHei',
                fontSize: chartSizeA,
            },
            // 轴线配置
            axisLine: {
                show: true, // 显示坐标轴线
                lineStyle: { // 轴线样式
                    color: "rgba(255,255,255,0.6)",
                },
            },
        },],
        yAxis: [{
            axisLine: {
                lineStyle: {
                    color: "rgba(255,255,255,0.6)",
                },
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: "rgba(255, 255, 255, 0.65)",
                fontSize: chartSizeA,
                fontFamily: 'Microsoft YaHei',
            },
            splitLine: {
                lineStyle: {
                    color: "rgba(0,145,255,0.3)",
                },
            }
        },],
        series: [{
            name: params.series[0].name,
            data: params.series[0].data,
            type: 'line',
            showAllSymbol: true,
            smooth: false, // 线性
            symbol: 'circle',
            symbolSize: chartSizeM,
            lineStyle: {
                width: 2,
                color: "#F7B500",
            },
            itemStyle: {
                color: "#FFF",
                borderColor: "#F7B500",
                borderWidth: 1,
            },
            areaStyle: {
                color: {
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                        offset: 0, color: 'rgba(247, 181, 0, 0.4)' // 100% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(247, 181, 0, 0)' // 0% 处的颜色
                    }],
                    global: false // 缺省为 false
                },
                shadowColor: 'rgba(247, 181, 0, 0.9)', //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            }
        }, {
            name: params.series[1].name,
            data: params.series[1].data,
            type: 'line',
            smooth: false, // 线性
            showAllSymbol: true,
            symbol: 'circle',
            symbolSize: chartSizeM,
            lineStyle: {
                width: 2,
                color: "rgba(66, 243, 255, 1)",
            },
            itemStyle: {
                color: "#FFF",
                borderColor: "rgba(66, 243, 255, 1)",
                borderWidth: 1,
            },
            areaStyle: {
                color: {
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                        offset: 0, color: 'rgba(66, 243, 255, 0.4)' // 100% 处的颜色
                    }, {
                        offset: 1, color: 'rgba(66, 243, 255, 0)' // 0% 处的颜色
                    }],
                    global: false // 缺省为 false
                },
                shadowColor: 'rgba(66, 243, 255, 0.9)', //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            }
        }]
    }
    params.chartId.setOption(option, true)
}

export {
    commonLineCharts, doubleLineCharts
}